import { useTheme } from '@mui/material';

export default function PlusButtonIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='16' cy='16' r='16' fill={theme.palette.primary.light} />
      <mask
        id='mask0_19968_92002'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='4'
        y='4'
        width='24'
        height='24'
      >
        <rect x='4' y='4' width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_19968_92002)'>
        <path
          d='M15.25 16.75H9.5V15.25H15.25V9.5H16.75V15.25H22.5V16.75H16.75V22.5H15.25V16.75Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
